import { ClosedLostSubmissionStage, FinanceInsurancePerformanceReportGroupBy, SubmissionStageFilter } from './types';

export { DATE_RANGE_OPTIONS } from '../pipelineAndWon/constants';

export const GROUP_BY_OPTIONS: { value: FinanceInsurancePerformanceReportGroupBy; label: string }[] = [
  { value: FinanceInsurancePerformanceReportGroupBy.SalesRep, label: 'Sales Rep' },
  { value: FinanceInsurancePerformanceReportGroupBy.Location, label: 'Location' },
  { value: FinanceInsurancePerformanceReportGroupBy.FinanceMgr, label: 'Finance Mgr' },
  { value: FinanceInsurancePerformanceReportGroupBy.SalesMgr, label: 'Sales Mgr' },
];

export const SUBMISSION_STAGE_OPTIONS: { value: ClosedLostSubmissionStage; label: string }[] = [
  { value: 'ALL', label: 'All' },
  { value: SubmissionStageFilter.SubmittedOnly, label: 'Submitted only' },
];
